import { CreditHistoryTypes, REQUEST_CREDIT_HISTORY, RECEIVE_CREDIT_HISTORY, ICreditHistoryResponse } from "./types";
import { CreditTypes, REQUEST_CREDIT_DATA, RECEIVE_CREDIT_DATA, REQUEST_DAILY_CREDIT, RECEIVE_DAILY_CREDIT, ICreditResponse, CreditEnrollmentActions, CREDIT_ENROLLMENT_DETAILS, LOADER_FOR_CREDIT_ENROLLMENT_DETAILS } from "./types";
import { CreditAuthTypes, RECEIVE_CREDIT_AUTH, REQUEST_CREDIT_AUTH } from "./types";
import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";
import { getServiceKey } from "../../util/credit";
import { formatDate } from "../../util/date";

export const actionCreators = {
    requestCreditHistory:
        (forceFullyRefresh: boolean): AppThunkAction<CreditHistoryTypes> =>
            (dispatch, getState) => {
                const appState = getState();
                let creditHistoryResponse: ICreditHistoryResponse[];
                if (
                    appState != null &&
                    appState.creditHistoryData != null &&
                    ((appState.creditHistoryData.creditHistoryData && appState.creditHistoryData.isLoading === false) || forceFullyRefresh === true)
                ) {
                    httpClient
                        .sendRequest("POST", `api/credit-monitoring/GetCreditHistory`, {})
                        .then((data) => {
                            const oneTimeOnlyReports = data.filter((report: any) => report.serviceCode.includes("SVCLVL-TU-CRDRPT"));
                            const oneTimeOnlyReportsWithScore = oneTimeOnlyReports.filter((report: any) => report.serviceCode.includes("SCORE"));
                            const reportsWithScore = data.filter((report: any) => report.serviceCode.includes("SCORE"));
                            const nonOneTimeReports = data.filter((report: any) => !report.serviceCode.includes("SVCLVL-TU-CRDRPT"));

                            const hasOneTimeReport = oneTimeOnlyReports && oneTimeOnlyReports.length > 0 ? true : false;
                            const hasOneTimeScore = oneTimeOnlyReportsWithScore && oneTimeOnlyReportsWithScore.length > 0 ? true : false;

                            const purchaseDisabled = getIsPurchaseDisabled(oneTimeOnlyReports);

                            const isOneTimeOnlyScore =
                                hasOneTimeScore && reportsWithScore && oneTimeOnlyReportsWithScore && reportsWithScore.length === oneTimeOnlyReportsWithScore.length;

                            const isOneTimeOnlyReport = hasOneTimeReport && nonOneTimeReports && nonOneTimeReports.length === 0;
                            // if report & score service code is different than report only service code, the report is the latest
                            const isOneTimeReportLatest =
                                hasOneTimeReport && hasOneTimeScore && oneTimeOnlyReportsWithScore[0].serviceCode !== oneTimeOnlyReports[0].serviceCode;

                            dispatch({
                                type: RECEIVE_CREDIT_HISTORY,
                                creditHistoryData: data,
                                isPurchaseDisabled: purchaseDisabled,
                                hasOneTimeReport: hasOneTimeReport,
                                hasOneTimeScore: hasOneTimeScore,
                                isOneTimeOnlyScore: isOneTimeOnlyScore,
                                isOneTimeOnlyReport: isOneTimeOnlyReport,
                                isOneTimeReportLatest: isOneTimeReportLatest,
                                oneTimeScoreServiceCode: isOneTimeOnlyScore ? oneTimeOnlyReportsWithScore[0].serviceCode : "",
                                oneTimeReportServiceCode: isOneTimeOnlyReport ? oneTimeOnlyReports[0].serviceCode : "",
                            });
                        })
                        .catch(function (error) {
                            dispatch({
                                type: RECEIVE_CREDIT_HISTORY,
                                creditHistoryData: creditHistoryResponse,
                                isPurchaseDisabled: false,
                                hasOneTimeReport: false,
                                hasOneTimeScore: false,
                                isOneTimeOnlyScore: false,
                                isOneTimeOnlyReport: false,
                                isOneTimeReportLatest: false,
                                oneTimeScoreServiceCode: "",
                                oneTimeReportServiceCode: "",
                            });
                        });

                    dispatch({
                        type: REQUEST_CREDIT_HISTORY,
                        creditHistoryData: [],
                        isPurchaseDisabled: false,
                        hasOneTimeReport: false,
                        hasOneTimeScore: false,
                        isOneTimeOnlyScore: false,
                        isOneTimeOnlyReport: false,
                        isOneTimeReportLatest: false,
                        oneTimeScoreServiceCode: "",
                        oneTimeReportServiceCode: "",
                    });
                }
            },
    requestCreditData:
        (forceFullyRefresh: boolean, bureauPermission: string, serviceCode?: string): AppThunkAction<CreditTypes> =>
            (dispatch, getState) => {
                const appState = getState();
                let creditResponse: ICreditResponse[];
                const hasServiceCodeChanged = getHasServiceCodeChanged(serviceCode ? serviceCode : "", appState);
                if (
                    appState != null &&
                    appState.creditState != null &&
                    !appState.creditState.hasError &&
                    ((appState.creditState.creditData == null && appState.creditState.isLoading === false && appState.creditHistoryData.isLoading === false) ||
                        forceFullyRefresh === true ||
                        (hasServiceCodeChanged && appState.creditState.creditData.length <= 1 && appState.creditState.isLoading === false))
                ) {
                    const requestBody = bureauPermission
                        ? {
                            "bureau-opt": bureauPermission ? getServiceKey(bureauPermission) : null,
                            "service-code": serviceCode ? serviceCode : "",
                        }
                        : {
                            "service-code": serviceCode ? serviceCode : "",
                        };

                    httpClient
                        .sendRequest("POST", `api/credit-monitoring/getCreditScoreData`, requestBody)
                        .then((data) => {
                            if (data.creditReport !== null || data.scores !== null) {
                                let creditData = [];
                                if (hasServiceCodeChanged) {
                                    creditData = addToArray(data, appState);
                                } else {
                                    creditData.push(data);
                                }
                                dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditData, hasError: false });
                            } else if ((data.IsIDFUser && data.IsExpired) || (data.IsIDFUser && data.IsScoreExpired)) {
                                let creditData = [];
                                creditData.push(data);
                                dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditData, hasError: false });
                            } else {
                                dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditResponse, hasError: false });
                            }
                        })
                        .catch(function (error) {
                            let hasErrorCount = 0;
                            if (appState.creditState.hasErrorCount && appState.creditState.hasErrorCount >= 1) {
                                hasErrorCount = appState.creditState.hasErrorCount + 1;
                            } else {
                                hasErrorCount++;
                            }

                            if (hasErrorCount && hasErrorCount >= 3) {
                                // if API fails 3 times in a row, then stop API from being called again
                                dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditResponse, hasError: true, hasErrorCount: hasErrorCount });
                            } else {
                                dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditResponse, hasError: false, hasErrorCount: hasErrorCount });
                            }
                        });

                    dispatch({ type: REQUEST_CREDIT_DATA });
                }
            },
    requestDailyCredit:
        (forceFullyRefresh: boolean, serviceCode?: string): AppThunkAction<CreditTypes> =>
            (dispatch, getState) => {
                const appState = getState();
                let creditResponse: ICreditResponse;
                if (
                    appState != null &&
                    appState.dailyCreditScoreData != null &&
                    ((appState.dailyCreditScoreData.dailyCreditData == null && appState.dailyCreditScoreData.isLoading === false) || forceFullyRefresh === true)
                ) {
                    const requestBody = {
                        "service-code": serviceCode ? serviceCode : "",
                    };
                    httpClient
                        .sendRequest("POST", `api/credit-monitoring/getCreditScoreData`, requestBody)
                        .then((data) => {
                            dispatch({ type: RECEIVE_DAILY_CREDIT, dailyCreditData: data });
                        })
                        .catch(function (error) {
                            dispatch({ type: RECEIVE_DAILY_CREDIT, dailyCreditData: creditResponse });
                        });

                    dispatch({ type: REQUEST_DAILY_CREDIT });
                }
            },
    refreshCredit:
        (hasCallback: boolean, refreshCallback: any, serviceCode?: string): AppThunkAction<CreditTypes> =>
            (dispatch, getState) => {
                const appState = getState();
                let creditResponse: ICreditResponse[];

                const requestBody = {
                    "service-code": serviceCode ? serviceCode : "",
                };
                httpClient
                    .sendRequest("POST", `api/credit-monitoring/refreshTUCreditReport`, requestBody)
                    .then((data) => {
                        if (data.creditReport !== null || data.scores !== null) {
                            let creditData = appState.creditState.creditData;
                            creditData.unshift(data); // add latest report to the top of the list

                            dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditData, hasError: false });
                        } else {
                            dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditResponse, hasError: false });
                        }
                        if (hasCallback && refreshCallback) {
                            refreshCallback();
                        }
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditResponse, hasError: false });
                        if (hasCallback && refreshCallback) {
                            refreshCallback();
                        }
                    });

                dispatch({ type: REQUEST_CREDIT_DATA });
            },
    refreshDailyCredit:
        (hasCallback: boolean, refreshCallback: any, serviceCode?: string): AppThunkAction<CreditTypes> =>
            (dispatch) => {
                let creditResponse: ICreditResponse;
                let requestBody = {
                    "service-code": serviceCode ? serviceCode : "",
                };

                httpClient
                    .sendRequest("POST", `api/credit-monitoring/refreshTUCreditReport`, requestBody)
                    .then((data) => {
                        dispatch({ type: RECEIVE_DAILY_CREDIT, dailyCreditData: data });
                        if (hasCallback && refreshCallback) {
                            refreshCallback();
                        }
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_DAILY_CREDIT, dailyCreditData: creditResponse });
                        if (hasCallback && refreshCallback) {
                            refreshCallback();
                        }
                    });

                dispatch({ type: REQUEST_DAILY_CREDIT });
            },
    requestValidateAuthentication: (): AppThunkAction<CreditAuthTypes> => (dispatch, getState) => {
        httpClient
            .sendRequest("POST", `api/credit-monitoring/validateAuthentication`)
            .then((data) => {
                let jsondata = data;
                dispatch({ type: RECEIVE_CREDIT_AUTH, authData: jsondata });
            })
            .catch(function (error) {
                console.log(error);
                let jsondata = {
                    "status-code": error.statusCode,
                    message: error.errorMessage,
                    data: null,
                    "auth-status": "",
                    "ssn-status": "",
                    "dob-status": "",
                    isIDFUser: false,
                };
                dispatch({ type: RECEIVE_CREDIT_AUTH, authData: jsondata });
            });
        dispatch({ type: REQUEST_CREDIT_AUTH });
    },
    getCreditEnrollmentDetails:
        (): AppThunkAction<CreditEnrollmentActions> =>
            (dispatch) => {
                httpClient
                    .sendRequest("GET", "web/user/GetFailedEnrollmentDetailsForUser")
                    .then((data) => {
                        dispatch({ type: CREDIT_ENROLLMENT_DETAILS, creditEnrollmentDetails: data });
                        dispatch({ type: LOADER_FOR_CREDIT_ENROLLMENT_DETAILS, isCreditEnrollmentDetailsLoaded: true });
                    })
                    .catch(function (error) {
                        dispatch({ type: CREDIT_ENROLLMENT_DETAILS, creditEnrollmentDetails: [] });
                        dispatch({ type: LOADER_FOR_CREDIT_ENROLLMENT_DETAILS, isCreditEnrollmentDetailsLoaded: false });
                    });
            }
};

function getIsPurchaseDisabled(oneTimeOnlyReports: any) {
    let isPurchaseDisabled = false;

    const latestOneTimeOnlyReport = oneTimeOnlyReports[0];
    const pulledDate = formatDate(latestOneTimeOnlyReport["alertDate"], latestOneTimeOnlyReport["createdTime"], false);
    const createdDate = new Date(pulledDate);
    const currentDate = new Date();
    const msBetweenDates = Math.abs(createdDate.getTime() - currentDate.getTime());

    // 👇️ convert ms to hours                  min  sec   ms
    const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

    if (hoursBetweenDates < 24) {
        isPurchaseDisabled = true;
    }
    return isPurchaseDisabled;
}

function getHasServiceCodeChanged(serviceCode: string, appState: any) {
    if (serviceCode && appState.creditState.creditData && appState.creditState.creditData.length > 0) {
        if (serviceCode !== appState.creditState.creditData[0]["score-service-code"] && appState.creditState.creditData.length >= 1) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function addToArray(data: any, appState: any) {
    appState.creditState.creditData.unshift(data);
    return appState.creditState.creditData;
}
